import { EnvelopeIcon, PhoneIcon } from '@heroicons/react/24/outline'
import { ReactComponent as MarylandIcon } from "../../assets/icons/maryland.svg";

export default function Contact() {
  return (
    <div className="relative bg-white">
      <div className="absolute inset-0">
        <div className="absolute inset-y-0 left-0 w-1/2 bg-gray-50" />
      </div>
      <div className="relative mx-auto max-w-7xl lg:grid lg:grid-cols-5">
        {/* Contact Info */}
        <div className="bg-gray-50 px-6 py-16 lg:col-span-2 lg:px-8 lg:py-24 xl:pr-12">
          <div className="mx-auto max-w-lg">
            <h2 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
              Get in touch
            </h2>
            <p className="mt-3 text-lg/6 text-gray-500">
              Ready to discuss your needs or get expert consulting? Reach
              out and let us know how we can help bring your vision to life.
            </p>
            <dl className="mt-8 text-base text-gray-500">
              <div>
                  <dt className="sr-only">Location</dt>
                  <dd className="flex">
                    <MarylandIcon
                      className="h-6 w-6 flex-shrink-0 text-gray-400"
                      aria-hidden="true"
                    />
                    <span className="ml-3 text-atticusOrange-600">Proudly based in Baltimore, MD</span>
                  </dd>
                </div>
              {/* If you have a public phone number, you can keep this; otherwise remove */}
              {/* <div className="mt-6">
                <dt className="sr-only">Phone number</dt>
                <dd className="flex">
                  <PhoneIcon aria-hidden="true" className="size-6 shrink-0 text-gray-400" />
                  <span className="ml-3">+1 (555) 123-4567</span>
                </dd>
              </div> */}
              <div className="mt-3">
                <dt className="sr-only">Email</dt>
                <dd className="flex">
                  <EnvelopeIcon aria-hidden="true" className="size-6 shrink-0 text-gray-400" />
                  <span className="ml-3">contact<span className="text-atticusPurple-400">@</span>atticuslabs.net</span>
                </dd>
              </div>
            </dl>
            {/* <p className="mt-6 text-base text-gray-500">
              Interested in joining our team?{' '}
              <a href="#" className="font-medium text-gray-700 underline">
                Send us a message
              </a>
              .
            </p> */}
          </div>
        </div>

        {/* Contact Form */}
        <div className="bg-white px-6 py-16 lg:col-span-3 lg:px-8 lg:py-24 xl:pl-12">
          <div className="mx-auto max-w-lg lg:max-w-none">
            <form action="#" method="POST" className="grid grid-cols-1 gap-y-6">
              <div>
                <label htmlFor="full-name" className="sr-only">
                  Full name
                </label>
                <input
                  id="full-name"
                  name="full-name"
                  type="text"
                  placeholder="Full name"
                  autoComplete="name"
                  className="block w-full rounded-md border border-gray-300 px-4 py-3 placeholder-gray-500 shadow-sm focus:border-atticusPink-400 focus:ring-atticusPink-400"
                />
              </div>
              <div>
                <label htmlFor="email" className="sr-only">
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Email"
                  autoComplete="email"
                  className="block w-full rounded-md border border-gray-300 px-4 py-3 placeholder-gray-500 shadow-sm focus:border-atticusPink-400 focus:ring-atticusPink-400"
                />
              </div>
              <div>
                <label htmlFor="phone" className="sr-only">
                  Phone
                </label>
                <input
                  id="phone"
                  name="phone"
                  type="text"
                  placeholder="Phone"
                  autoComplete="tel"
                  className="block w-full rounded-md border border-gray-300 px-4 py-3 placeholder-gray-500 shadow-sm focus:border-atticusPink-400 focus:ring-atticusPink-400"
                />
              </div>
              <div>
                <label htmlFor="message" className="sr-only">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={4}
                  placeholder="Tell us about your project..."
                  className="block w-full rounded-md border border-gray-300 px-4 py-3 placeholder-gray-500 shadow-sm focus:border-atticusPink-400 focus:ring-atticusPink-400"
                  defaultValue={''}
                />
              </div>
              <div>
                <button
                  type="submit"
                  className="inline-flex justify-center rounded-md border border-transparent bg-atticusPink-600 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-atticusPink-800 focus:outline-none focus:ring-2 focus:ring-atticusPink-400 focus:ring-offset-2"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}
